import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export default function useSyncState<T>(
  state: T,
  setState?: Dispatch<SetStateAction<T>>,
): [T, Dispatch<SetStateAction<T>>] {
  const [_state, _setState] = useState<T>(state);
  useEffect(() => _setState(state), [state]);

  return [_state, setState ?? _setState];
}
